const PHP_SYMBOL = '₱';

const trimmedAmountFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatMoney = (value: number | string): string => {
  const numericValue =
    typeof value === 'string' ? Number.parseFloat(value) : value;

  const safeValue = Number.isFinite(numericValue) ? Math.abs(numericValue) : 0;
  return `${PHP_SYMBOL}${trimmedAmountFormat.format(safeValue)}`;
};
